import "./Sidebar.css";
import React, { Fragment, useEffect, useState } from "react";
import { getAuth } from "firebase/auth";
import GetUser from "../../Controllers/Users/GetUser";
import { AdminRoutes } from "../../Routes/AdminRoutes";
import { useLocation } from "react-router-dom";
import SideBarItem from "./SideBarItem";
import { TeacherRoutes } from "../../Routes/TeacherRoutes";
import { StudentRoutes } from "../../Routes/StudentRoutes";
import { SuperAdminRoutes } from "../../Routes/SuperAdminRoutes";
import { ParentRoutes } from "../../Routes/ParentRoutes";

const Sidebar = () => {
  const path = useLocation().pathname;
  const [CurrentAuth, setCurrentAuth] = useState({});

  useEffect(() => {
    async function fetchData() {
      getAuth().onAuthStateChanged(async (user) => {
        const UserData = await GetUser(user?.uid);
        setCurrentAuth(UserData);
      });
    }
    fetchData();
  }, []);

  document?.getElementById("sidebar")?.addEventListener("mouseover", () => {
    if (document.getElementById("root").classList.contains("mini-sidebar")) {
      document.getElementById("root").classList.add("expand-menu");
    }
  });
  document?.getElementById("sidebar")?.addEventListener("mouseleave", () => {
    if (document.getElementById("root").classList.contains("mini-sidebar")) {
      document.getElementById("root").classList.remove("expand-menu");
    }
  });
  const [indexGlobal, setIndexGlobal] = useState(-1);
  const [indexGlobalOpen, setIndexGlobalOpen] = useState(-1);

  const [isUserSuperAdmin, setIsUserSuperAdmin] = useState(false);

  useEffect(() => {
    async function fetchData() {
      getAuth().onAuthStateChanged(async (user) => {
        const UserData = await GetUser(user?.uid);

        if (user) {
          user.getIdTokenResult().then((idTokenResult) => {
            if (idTokenResult.claims.admin) {
              setIsUserSuperAdmin(true);
            } else {
              setCurrentAuth(UserData);
            }
          });
        }
      });
    }
    fetchData();
  }, []);

  return (
    <div className="sidebar-container">
      {/* Sidebar */}
      <div className="sidebar" id="sidebar">
        <div className="sidebar-inner slimscroll">
          <div id="sidebar-menu" className="sidebar-menu">
            {isUserSuperAdmin === true ? (
              <ul>
                {SuperAdminRoutes.filter((route) => route.parent).map(
                  (item, keyIndex) => {
                    const IsActive = path === item.path;
                    const IsChildActive = path.includes(item.path);

                    return (
                      <SideBarItem
                        item={item}
                        keyIndex={keyIndex}
                        IsChildActive={IsChildActive}
                        IsActive={IsActive}
                        setIndexGlobal={setIndexGlobal}
                        indexGlobal={indexGlobal}
                        setIndexGlobalOpen={setIndexGlobalOpen}
                        indexGlobalOpen={indexGlobalOpen}
                      />
                    );
                  }
                )}
              </ul>
            ) : CurrentAuth.UserType === "admin" ? (
              <ul>
                {AdminRoutes.filter((route) => route.parent).map(
                  (item, keyIndex) => {
                    const IsActive = path === item.path;
                    const IsChildActive = path.includes(item.path);

                    return (
                      <SideBarItem
                        item={item}
                        keyIndex={keyIndex}
                        IsChildActive={IsChildActive}
                        IsActive={IsActive}
                        setIndexGlobal={setIndexGlobal}
                        indexGlobal={indexGlobal}
                        setIndexGlobalOpen={setIndexGlobalOpen}
                        indexGlobalOpen={indexGlobalOpen}
                      />
                    );
                  }
                )}
              </ul>
            ) : CurrentAuth.UserType === "teacher" ? (
              <ul>
                {TeacherRoutes.filter((route) => route.parent).map(
                  (item, keyIndex) => {
                    const IsActive = path === item.path;
                    const IsChildActive = path.includes(item.path);

                    return (
                      <SideBarItem
                        item={item}
                        keyIndex={keyIndex}
                        IsChildActive={IsChildActive}
                        IsActive={IsActive}
                        setIndexGlobal={setIndexGlobal}
                        indexGlobal={indexGlobal}
                        setIndexGlobalOpen={setIndexGlobalOpen}
                        indexGlobalOpen={indexGlobalOpen}
                      />
                    );
                  }
                )}
              </ul>
            ) : CurrentAuth.UserType === "student" ? (
              <ul>
                {StudentRoutes.filter((route) => route.parent).map(
                  (item, keyIndex) => {
                    const IsActive = path === item.path;
                    const IsChildActive = path.includes(item.path);

                    return (
                      <SideBarItem
                        item={item}
                        keyIndex={keyIndex}
                        IsChildActive={IsChildActive}
                        IsActive={IsActive}
                        setIndexGlobal={setIndexGlobal}
                        indexGlobal={indexGlobal}
                        setIndexGlobalOpen={setIndexGlobalOpen}
                        indexGlobalOpen={indexGlobalOpen}
                      />
                    );
                  }
                )}
              </ul>
            ) : CurrentAuth.UserType === "parent" ? (
              <ul>
                {ParentRoutes.filter((route) => route.parent).map(
                  (item, keyIndex) => {
                    const IsActive = path === item.path;
                    const IsChildActive = path.includes(item.path);

                    return (
                      <SideBarItem
                        item={item}
                        keyIndex={keyIndex}
                        IsChildActive={IsChildActive}
                        IsActive={IsActive}
                        setIndexGlobal={setIndexGlobal}
                        indexGlobal={indexGlobal}
                        setIndexGlobalOpen={setIndexGlobalOpen}
                        indexGlobalOpen={indexGlobalOpen}
                      />
                    );
                  }
                )}
              </ul>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
      {/* /Sidebar */}
    </div>
  );
};

export default Sidebar;
